<template>
    <div class="content_box mobile_content">
        <div class="content role">
            <div class="title_box">
                <span class="title">角色列表</span>
            </div>
            <div class="button button2 add" @click="addRole" v-if="roleCheck('190-101-102-102')">
                <i class="el-icon-plus"></i>
                <span>新增角色</span>
            </div>
            <el-table
                highlight-current-row
                :data="listData"
                style="width: 100%">
                <el-table-column prop="role_name" label="角色名称" min-width="100"></el-table-column>
                <el-table-column prop="desc" label="角色描述" min-width="200"></el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope" >
                        <div v-if="scope.row.role_id != '10001'">
                            <div class="button text" @click="updatePermission(scope.row)" v-if="roleCheck('190-101-102-103')">设置权限</div>
                            <div class="button text" @click="roleUpdate(scope.row)" v-if="roleCheck('190-101-102-102')">编辑</div>
                            <div class="button text del_btn" @click="delRole(scope.row)" v-if="roleCheck('190-101-102-104')">删除</div>
                        </div>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            <Tip ref="tip" msg="确定要删除该角色吗，请确认该角色下是否有关联的用户" @tipBack="delRolerConfirm"></Tip>
            <Gh-Dialog ref="dislog" :title="dislog.title" @dialogBack="updateConfirm">
                <template v-slot:content>
                    <el-form label-width="100px">
                         <el-form-item label="角色名称">
                            <el-input v-model="roleData.role_name" maxlength="20" placeholder="请输入角色名称"></el-input>
                        </el-form-item>
                        <el-form-item label="角色描述">
                            <el-input type="textarea" rows="5" maxlength="100" v-model="roleData.desc" show-word-limit placeholder="请输入角色描述"></el-input>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default({
    name: 'role',
    data() {
        return {
            searchData: {
                page_size: 10,
                page: 1
            },
            total: 0,
            listData: [],
            type: '',
            dislog: {
                type: '',
                title: ''
            },
            roleData: {
                role_id: '',
                role_name: '',
                desc: ''
            }
        }
    },
    activated() {
        this.getRole();
    },
    methods: {
        addRole() {
            this.dislog = {
                type: 'add',
                title: '新增角色'
            };
            this.roleData = {
                role_name: '',
                desc: ''
            };
            this.$refs.dislog.show = true;
        },
        getRole() {
            this.api.getRole(this.searchData).then(data => {
                this.listData = data.data.roleList;
                this.total = data.data.total;
            })
        },
        roleUpdate(item) {
            this.dislog = {
                type: 'update',
                title: '修改角色'
            };
            this.roleData = {
                role_id: item.role_id,
                role_name: item.role_name,
                desc: item.desc
            };
            this.$refs.dislog.show = true;
        },
        updateConfirm() {
            if(!this.roleData.role_name){
                this.$message.warning('请输入角色名称!');
                return;
            }else if(!this.roleData.desc){
                this.$message.warning('请输入角色描述!');
                return;
            }
            if(this.dislog.type == 'add'){
                this.api.addRole(this.roleData).then(data => {
                    this.$message.success('新增角色成功！');
                    this.getRole();
                    this.$refs.dislog.show = false;
                })  
            }else{
                this.api.updateRole(this.roleData).then(data => {
                    this.$message.success('修改成功！');
                    this.getRole();
                    this.$refs.dislog.show = false;
                })
            }
        },
        updatePermission(item) {
            this.$router.push({name: 'permission', query: {role_id: item.role_id, role_name: item.role_name, p: item.permission ? item.permission.join(',') : ''}});
        },
        delRole(item) {
            this.$refs.tip.show = true;
            this.roleData.role_id = item.role_id;
        },
        delRolerConfirm() {
            this.api.delRole({role_id: this.roleData.role_id}).then(data => {
                this.$message.success('删除成功！');
                this.getRole();
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getRole();
        },
    }
})
</script>
<style lang="less" scoped>
   
</style>



// WEBPACK FOOTER //
// src/view/settings/role.vue